import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/Base/App';
import { unregister }  from './registerServiceWorker';

ReactDOM.render(<App/>, document.getElementById('root'));

unregister();



// WEBPACK FOOTER //
// ./src/index.js